import { ReactNode, MouseEvent } from 'react';
import { IconChevron, SwirlSocialProof } from '@bridebook/ui/src/icons/dynamic';
import Box from '../../../components/fela/Box';
import componentStyles, { Theme } from './support-message.style';
import { TColor } from '@bridebook/ui/src/themes/types';

interface IProps {
  /** Title of banner */
  title?: ReactNode;
  /** Content of banner */
  children?: ReactNode;
  /** What theme to use */
  theme?: Theme;
  /** If banner will have an arrow to the right */
  withArrow?: boolean;
  /** Icon that will be displayed on the left */
  icon?: ReactNode;
  /** Action performed on banner click */
  onClick?: (event: MouseEvent<ReactNode>) => void;
  /** Font sizes of the banner */
  size?: 'small' | 'default' | 'large';
  /** Enable swirl in background */
  withSwirl?: boolean;
}

const getSwirlColor = (theme?: Theme): TColor => {
  switch (theme) {
    case 'success':
      return 'teal40';
    case 'alert':
      return 'peachRose40';
    case 'error':
      return 'blushTangerine40';
    case 'primary':
    default:
      return 'indigoCrush20';
  }
};

/**
 * @deprecated
 * Use SupportMessage from bridebook/aura instead.
 */
export const SupportMessage = ({
  title,
  icon,
  theme,
  withArrow,
  onClick,
  size = 'default',
  children,
  withSwirl,
}: IProps) => {
  const styles = componentStyles({
    isClickable: !!onClick,
    theme,
    size,
    hasIcon: !!icon,
  });

  return (
    <Box style={styles.wrapper} onClick={onClick}>
      {withSwirl && (
        <Box style={styles.backgroundSwirl}>
          <SwirlSocialProof color={getSwirlColor(theme)} />
        </Box>
      )}
      <Box style={styles.contentWrapper}>
        {icon && <Box style={styles.iconWrap}>{icon}</Box>}
        {title && <Box style={styles.title}>{title}</Box>}
        {children && <Box style={styles.description}>{children}</Box>}
      </Box>
      {withArrow && <IconChevron width={12} style={styles.arrow} />}
    </Box>
  );
};
